<template>
    <div class="sidebar-detail">
        <!-- :title="`${detailInfo.name || '----' } ${qrCode}`" -->
        <detail-header
            title="Program"
            @refreshDetailPage="refreshDetailPage"
            @closeDetailPage="closeDetailPage"
        />

        <div v-if="detailInfo">
            <p class="detail-title">Details</p>
            <div>
                <table class="recording-detail-table">
                    <tr>
                        <td>Id</td>
                        <td>{{ detailInfo.id }}</td>
                    </tr>
                    <tr>
                        <td>Code</td>
                        <td>{{ detailInfo.code }}</td>
                    </tr>
                    <tr>
                        <td>Title</td>
                        <td>{{ detailInfo.title || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Objective</td>
                        <td>{{ detailInfo.objective || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Mating Design</td>
                        <td>{{ (detailInfo.matingDesign||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Location</td>
                        <td>{{ (detailInfo.location||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Person In Charge</td>
                        <td>{{ (detailInfo.employeeInCharge||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Start Date</td>
                        <td>{{ $_getMyrDateFormat(detailInfo.startDate) || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Complete Date</td>
                        <td>{{ $_getMyrDateFormat(detailInfo.completeDate) || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Keywords</td>
                        <td>
                            <program-keyword-chip :row="detailInfo" />
                        </td>
                    </tr>
                    <tr>
                        <td class="table-section" colspan="2">Status</td>
                    </tr>
                    <tr>
                        <td>Status</td>
                        <td>{{ (detailInfo.researchStatus||{}).name || "-" }}</td>
                    </tr>
                </table>
            </div>

            <p class="detail-title detail-title-pd">Date Time</p>
            <div class="user-datetime-container">
                <table>
                    <tr>
                        <td>Modified</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.lastModificationTime) }} {{ $t('detail.by') }} {{ (detailInfo.lastModifierUser||{}).userName || '-' }}</td>
                    </tr>
                    <tr>
                        <td>Created</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.creationTime) }} {{ $t('detail.by') }} {{ (detailInfo.creatorUser||{}).userName || '-' }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import DetailHeader from "./DetailHeader";
import { programGet } from "@/api/program";
import ProgramKeywordChip from "@/components/Programme/ProgramKeywordChip";

export default {
    components: {
        "detail-header": DetailHeader,
        "program-keyword-chip": ProgramKeywordChip
    },
    props: {
        infoSidebarId: {
            type: Number | String
        }
    },
    data() {
        return {
            detailInfo: null
        };
    },
    watch: {
        infoSidebarId: {
            immediate: true,
            handler() {
                this.getDetails();
            },
        }
    },
    methods: {
        async getDetails() {
            if (this.infoSidebarId) {
                var res = await programGet({ Id: this.infoSidebarId });
                if (res) {
                    this.detailInfo = res;
                }
            }
        },
        refreshDetailPage() {
            this.getDetails();
        },
        closeDetailPage() {
            this.$store.dispatch("info_sidebar/setInfoSidebar");
        }
    }
};
</script>

<style scoped>
.stepper-container {
    padding: var(--space-16) 0;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/ProgramSidebar.vue